(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-anmeldelser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('npr-reviews')) return;
 
    class NprReviews extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.grid = this.querySelector('[data-npr-grid]');
        this.moreBtn = this.querySelector('[data-npr-more]');
        this.cards = Array.from(this.querySelectorAll('[data-npr-card]'));
        this.step = Math.max(1, parseInt(this.dataset.initial, 10) || 10);
        this.maxCols = Math.max(1, parseInt(this.dataset.maxCols, 10) || 4);
        this.shown = Math.min(this.step, this.cards.length);
        this.cols = 0;
 
        this.moreBtn.addEventListener('click', () => {
          this.shown = Math.min(this.shown + this.step, this.cards.length);
          this.layout(true);
        });
        this.cards.forEach((card) =>
          card.querySelectorAll('img').forEach((img) => {
            if (!img.complete) img.addEventListener('load', () => this.layout(true), { once: true });
          })
        );
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.layout(false));
          this.ro.observe(this);
        }
        this.layout(true);
      }
 
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
      }
 
      columnCount() {
        var width = this.grid.clientWidth || this.clientWidth;
        var min = window.matchMedia('(max-width: 749px)').matches ? 150 : 240;
        return Math.max(1, Math.min(this.maxCols, Math.floor((width + 18) / (min + 18))));
      }
 
      layout(force) {
        var cols = this.columnCount();
        if (!force && cols === this.cols) return;
        this.cols = cols;
        var columns = [];
        var heights = [];
        var frag = document.createDocumentFragment();
        for (var c = 0; c < cols; c++) {
          var col = document.createElement('div');
          col.className = 'npr__col';
          columns.push(col);
          heights.push(0);
          frag.appendChild(col);
        }
        var parking = document.createDocumentFragment();
        this.cards.forEach((card, i) => {
          card.hidden = i >= this.shown;
          if (card.hidden) parking.appendChild(card);
        });
        this.grid.textContent = '';
        this.grid.appendChild(frag);
        this.grid.classList.add('is-masonry');
        this.cards.forEach((card, i) => {
          if (i >= this.shown) return;
          var target = heights.indexOf(Math.min.apply(null, heights));
          columns[target].appendChild(card);
          heights[target] = columns[target].offsetHeight;
        });
        this.grid.appendChild(parking);
        this.moreBtn.hidden = this.shown >= this.cards.length;
      }
    }
 
    customElements.define('npr-reviews', NprReviews);
  })();

  } catch(e) { console.error(e); }
})();
})();
